const rows = [
  { feature: "Processing Speed", us: "24 hrs – 10 business days", them: "8–11 weeks standard" },
  { feature: "Personal Support", us: "Dedicated agent assigned to your case", them: "None — self-service only" },
  { feature: "Document Review", us: "Expert review included before submission", them: "Self-check — errors cause delays" },
  { feature: "State Dept. Courier", us: "Registered courier — direct submission", them: "Standard mail routing" },
  { feature: "Real-Time Tracking", us: "Yes — daily status updates", them: "Limited or no tracking" },
  { feature: "Best Price Guarantee", us: "Yes — find a lower rate, we'll match", them: "No price matching" },
  { feature: "A+ BBB Rating", us: "Yes — 20+ years of trusted service", them: "Varies by location" },
  { feature: "Corporate Group Processing", us: "Supported — Walmart, Daisy, NWA teams", them: "Not available" },
];

export default function RogersComparisonSection() {
  return (
    <section id="compare" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Compare</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Fast Passport Center vs. DIY Government Processing</h2>
        </div>
        <div className="mb-8 bg-amber-50 border border-[#F6C344]/40 rounded-lg p-6">
          <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">
            Rogers Passport Agency Appointment Not Available?
          </h3>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Regional passport agency appointments are routinely booked 2–4 weeks out — and walk-ins are never accepted. If you searched for an appointment and came up empty, Fast Passport Center's registered courier channel is your fastest next step. No appointment. No waiting in line at the federal building. Processing as fast as 2–3 business days.
          </p>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="grid grid-cols-3 border-b border-gray-200 bg-[#EEF2F8]">
            <div className="p-4 font-bold text-[#1A365D] text-sm">Feature</div>
            <div className="p-4 font-bold text-[#1A365D] text-sm text-center">Fast Passport Center</div>
            <div className="p-4 font-bold text-gray-500 text-sm text-center">Government Standard</div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 ${i !== rows.length - 1 ? "border-b border-gray-100" : ""}`}>
              <div className="p-4 text-sm text-gray-600 font-medium">{row.feature}</div>
              <div className="p-4 text-sm text-[#1A365D] font-semibold text-center bg-[#F7F8FA]/50">{row.us}</div>
              <div className="p-4 text-sm text-gray-500 text-center">{row.them}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}